import AnimatedPercentage from '@components/Animation/AnimatedPercentage';
import {memo} from 'react';
import {StatsContainer} from './GridCardStats.styled';

interface Props {
  stat: number;
  noPrivacy: boolean;
  small: boolean;
  isInFuture: boolean;
  loading: boolean;
}

const GridCardStats = (props: Props) =>
  props.noPrivacy ? (
    <StatsContainer small={props.small} isInFuture={props.isInFuture}>
      {props.stat ? (
        <AnimatedPercentage bold={!props.small} content={props.stat?.toFixed(1)} loading={props.loading} />
      ) : (
        <div>{props.stat?.toFixed(1)}%</div>
      )}
    </StatsContainer>
  ) : null;

export default memo(GridCardStats);
